const page_name = 1
export default {
  // page_name##页面名称(1:商品详情页)&&
  // details_content##图文详情内容id(1:资源位;2:规格参数;3:关注我们;4:免责声明)&&
  // sku_id##商品skuid
  introduction: ({ sku_id, details_content }) => [
    {
      act: 'show',
      params: { cfrom: '184|001|02|077', event_id: '184|001|02|077', page_name, sku_id, details_content }
    },
    {
      act: 'click',
      params: { cfrom: '184|001|01|077', event_id: '184|001|01|077', page_name, sku_id, details_content }
    }
  ]
}
